export default __webpack_public_path__ + "static/media/hw-guards.0831817a.jpg";